<template>
    <div class="mx-2 pb-8 lg:mx-0 content-top pr-1 sm:pr-6">
        <Head title="Settings" />

        <div v-if="$page.props.jetstream.canUpdateProfileInformation">
            <update-bio-form />

            <jet-section-border />
        </div>

        <div v-if="$page.props.jetstream.canUpdateProfileInformation">
            <update-profile-information-form />

            <jet-section-border />
        </div>

        <div>
            <payout-method class="mt-10 sm:mt-0" />

            <jet-section-border />
        </div>

        <div v-if="$page.props.jetstream.canUpdatePassword && $page.props.socialstream.hasPassword">
            <update-password-form class="mt-10 sm:mt-0" />

            <jet-section-border />
        </div>

        <div v-else>
            <set-password-form class="mt-10 sm:mt-0" />

            <jet-section-border />
        </div>

        <!--<div>-->
        <!--    <update-theme class="mt-10 sm:mt-0" />-->

        <!--    <jet-section-border />-->
        <!--</div>-->

        <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication && $page.props.socialstream.hasPassword">
            <two-factor-authentication-form class="mt-10 sm:mt-0" />

            <jet-section-border />
        </div>

        <div v-if="$page.props.socialstream.show">
            <connected-accounts-form class="mt-10 sm:mt-0" />
        </div>

        <div v-if="$page.props.socialstream.hasPassword">
            <jet-section-border />

            <logout-other-browser-sessions-form :sessions="sessions" class="mt-10 sm:mt-0" />
        </div>

        <div v-if="$page.props.socialstream.hasPassword">
            <jet-section-border />

            <delete-user-form class="mt-10 sm:mt-0" />
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import DeleteUserForm from "./DeleteUserForm"
import JetSectionBorder from "@/Jetstream/SectionBorder"
import LogoutOtherBrowserSessionsForm from "./LogoutOtherBrowserSessionsForm"
import TwoFactorAuthenticationForm from "./TwoFactorAuthenticationForm"
import SetPasswordForm from "./SetPasswordForm"
import UpdatePasswordForm from "./UpdatePasswordForm"
import UpdateProfileInformationForm from "./UpdateProfileInformationForm"
import ConnectedAccountsForm from "./ConnectedAccountsForm"
import UpdateTheme from "./UpdateTheme"
import PayoutMethod from "@/Pages/Settings/Profile/PayoutMethod"
import UpdateBioForm from "@/Pages/Settings/Profile/UpdateBioForm"

export default {
    name: "ProfileSettings",

    layout: AppLayout,

    props: ["sessions"],

    components: {
        UpdateBioForm,
        PayoutMethod,
        UpdateTheme,
        ConnectedAccountsForm,
        AppLayout,
        DeleteUserForm,
        JetSectionBorder,
        LogoutOtherBrowserSessionsForm,
        TwoFactorAuthenticationForm,
        SetPasswordForm,
        UpdatePasswordForm,
        UpdateProfileInformationForm,
    },
}
</script>
